(function(){
  var nav = document.getElementById('nav');
  if (nav){
    var onScroll = function(){ nav.classList.toggle('nav--scrolled', window.scrollY > 24); };
    window.addEventListener('scroll', onScroll, {passive:true}); onScroll();
  }
  // smooth-scroll any link whose hash target exists on this page
  document.addEventListener('click', function(e){
    var a = e.target.closest('a[href*="#"]'); if (!a) return;
    var url = new URL(a.href, location.href);
    if (url.pathname !== location.pathname || !url.hash) return;
    var el = document.querySelector(url.hash); if (!el) return;
    e.preventDefault();
    el.scrollIntoView({behavior:'smooth'});
    history.replaceState(null, '', url.hash);
  });
})();
